import { create } from "zustand";

interface IPointsStore {
    puntos: number;
    incrementarPuntos: (puntos: number) => void;
    restarPuntos: (puntos: number) => void;
    establecerPuntos: (puntos: number) => void;
}

export const usePointsStore = create<IPointsStore>()((set) => ({
    puntos: 0,
    incrementarPuntos: (puntos: number) =>
        set((state) => {
            const nuevosPuntos = state.puntos + puntos;

            return {
                ...state,
                puntos: nuevosPuntos,
            };
        }),
    restarPuntos: (puntos: number) =>
        set((state) => {
            let nuevosPuntos = state.puntos - puntos;
            if (nuevosPuntos < 0) {
                nuevosPuntos = 0;
            }

            return {
                ...state,
                puntos: nuevosPuntos,
            };
        }),
    establecerPuntos: (puntos: number) =>
        set((state) => {
            return {
                ...state,
                puntos: puntos,
            };
        }),
}));
